module.exports = __webpack_public_path__ + "img/Layer 14.5ca8fcf2.svg";